import { graphql } from '../graphql/generated';

export const OPEN_FRONT_DESK_REQUESTS_QUERY = graphql(`
  query OpenFrontDeskRequests {
    openFrontDeskRequests {
      id
      createdAt
      sampledAt
      patientData {
        title
        firstName
        lastName
        svnr
      }
      doctor {
        id
        name
        meAddress
        assignedLabs {
          customerId
        }
      }
      orders {
        id
        number
      }
    }
  }
`);
